Namespace 'Customer.Views.Insights'

class Customer.Views.Insights.ActivityMetricSelectorsContainer extends Backbone.View
  events:
    'change #activity-type': 'resetSelectableColumns'
    'click .column-controls .select-all': '_selectAllColumns'
    'click .column-controls .clear-all': '_clearAllColumns'

  initialize: ({@columns, @columnGroups, @contentTypeExclusiveColumns, @subtypes}) ->
    @columnsToDisplay = @columns[@_currentReportType()]
    @defaultSelectedColumns = ['created', 'assignations', 'responses', 'closures', 'average_handle_time', 'schedules']

  render: ->
    columnFiltersContainer = @$('#column-filters')
    columnFiltersContainer.empty()
    Object.entries(@columnGroups[@_currentReportType()]).forEach(([groupName, columnsKeys]) =>
      columns = columnsKeys.filter((column) => @columnsToDisplay.includes(column))
      subtype = _.find(@_integratedSubtypes(), (subtype) -> subtype == groupName)
      unless subtype and subtype not in @subtypes
        activityColumnSelectorView = new Customer.Views.Insights.ActivityMetricGroupSelectorView
          title: groupName
          columns: columns
          defaultSelectedColumns: @defaultSelectedColumns
          extraClassName: "#{groupName}-group"
        columnFiltersContainer.append(activityColumnSelectorView.render())
    )

  resetSelectableColumns: ->
    excludedColumns = []
    $('.subtype-selector-checkbox').each((_, element) =>
      currentCheckbox = $(element)
      currentSubtype = currentCheckbox.val()
      checkedValue = currentCheckbox.prop('checked')
      currentExlusiveColumns = @_exclude_metrics_by_subtype(currentSubtype, checkedValue)
      excludedColumns = excludedColumns.concat(currentExlusiveColumns)
    )
    @_resetColumnsAndExclude(excludedColumns)

  _resetColumnsAndExclude: (excludedColumns) ->
    @columnsToDisplay = @columns[@_currentReportType()].filter((column) -> column not in excludedColumns)
    @render()

  _exclude_metrics_by_subtype: (subtype, checkStatus) ->
    excludedCols = []
    excludedCols = @contentTypeExclusiveColumns[subtype] unless checkStatus
    excludedCols

  _currentReportType: ->
    @$('#activity-type').find('input:checked').val()

  _selectAllColumns: ->
    @_toggleAllColumns true

  _clearAllColumns: ->
    @_toggleAllColumns false

  _toggleAllColumns: (checked) ->
    @$('.available-column').find('input').prop('checked', checked)

  _integratedSubtypes: ->
    ['webchat']
